import { Container } from "@gromia/components/ui/Grid";
import { Header } from "@gromia/components/ui/Header";
import { Layout } from "@gromia/components/ui/Layout";
import * as React from "react";

export default function Page() {
  return (
    <Layout>
      <Header />
      <Container>
        <div style={{ paddingTop: "5rem", paddingBottom: "5rem" }}>
          <p>
            On page load Gatsby puts a `gatsby-route-change` event on the GTM
            Data Layer.
          </p>
          <p>
            We configured GTM to fire the following JS script when a
            `gatsby-route-change` is triggered on this page.
          </p>
          <pre>_fbevent('trackCustom', 'TestLead')</pre>
        </div>
      </Container>
    </Layout>
  );
}
